var fileReader = {
  readAsDataURL: function(file) {
    var promise = new Promise(function(resolve, reject) {
      var reader = new FileReader();

      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.result);
      };
      //reader.onprogress = onProgress(reader);

      reader.readAsDataURL(file);
    });
    return promise;
  }
};

module.exports = fileReader;
